import { render, staticRenderFns } from "./SingleArticle.vue?vue&type=template&id=0cc60cd1&"
import script from "./SingleArticle.vue?vue&type=script&lang=js&"
export * from "./SingleArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports